import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromAuth from '../reducers/auth.reducers';


export const selectAuthState = createFeatureSelector<fromAuth.State>('auth');
export const selectAuthErrorMessage = createSelector(
  selectAuthState,
  (state: fromAuth.State) => state.errorMessage
);

export const selectToken = createSelector(
  selectAuthState,
  (state: fromAuth.State) => state.user?.token || null
);

export const seelectIsLoading = createSelector(
  selectAuthState,
  (state: fromAuth.State) => state.loading
);
